module.exports = __webpack_public_path__ + "img/settings.636ea8f5.svg";